var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from 'styled-components';
import useHasReactRouterContext from '../../hooks/useHasReactRouterContext';
import { getModeByBackgroundColor } from '../../helpers/colors';
import { RadioLabel, TagContent, TagRadio, TagWrapper } from './tagstyles';
export function TagV2(_a) {
    var { backgroundColor = 'lightgrey' } = _a, props = __rest(_a, ["backgroundColor"]);
    const hasReactRouterContext = useHasReactRouterContext();
    const { colors } = useTheme();
    const color = getModeByBackgroundColor(colors[backgroundColor]) === 'light'
        ? 'darkergrey'
        : 'white';
    const { 'data-trackingid': dataTrackingId, 'data-testid': dataTestId, children, } = props;
    if ('href' in props) {
        const { href } = props;
        if (hasReactRouterContext && !href.startsWith('https://')) {
            return (React.createElement(TagWrapper, { "data-testid": dataTestId },
                React.createElement(Link, { to: href, "data-testid": "tag-v2-routerlink", "data-trackingid": dataTrackingId },
                    React.createElement(TagContent, { backgroundColor: backgroundColor, color: color }, children))));
        }
        else {
            const targetProps = href.startsWith('https://')
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : {};
            return (React.createElement(TagWrapper, null,
                React.createElement("a", Object.assign({ href: href, "data-testid": "tag-v2-link", "data-trackingid": dataTrackingId }, targetProps),
                    React.createElement(TagContent, { backgroundColor: backgroundColor, color: color }, children))));
        }
    }
    if ('value' in props) {
        const { isChecked = undefined, name, value, onChange } = props;
        const id = `radio_${name}_${value}`;
        return (React.createElement(TagWrapper, null,
            React.createElement(TagRadio, { "data-trackingid": dataTrackingId, type: "radio", id: id, name: name, checked: isChecked, value: value, onChange: onChange, "data-testid": dataTestId }),
            React.createElement(RadioLabel, { htmlFor: id },
                React.createElement(TagContent, { backgroundColor: isChecked ? 'primary' : backgroundColor, color: isChecked ? 'white' : color }, children))));
    }
    return (React.createElement(TagWrapper, { "data-testid": dataTestId },
        React.createElement(TagContent, { backgroundColor: backgroundColor, color: color }, children)));
}
